import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const CaretRightIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" d="m12 23.936 7.935-7.904L12.13 8" />
  </IconV2>
);

export default CaretRightIcon;
